module.exports = new __parcel__URL__("verdantpyre.b9d4969a.png").toString();